import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie, detectIconById } from '../common/enum';
import moment from 'moment';
import numeral from 'numeral';

const ACTIONS = {
	GET_ITEM_DASHBOARDS_TEAM_SUCCESS: 'GET_ITEM_DASHBOARDS_TEAM_SUCCESS',
	GET_ITEM_DASHBOARDS_TEAM_ERROR: 'GET_ITEM_DASHBOARDS_TEAM_ERROR',
	GET_ITEM_DASHBOARDS_SUCCESS: 'GET_ITEM_DASHBOARDS_SUCCESS',
	GET_ITEM_DASHBOARDS_ERROR: 'GET_ITEM_DASHBOARDS_ERROR',
	GET_DROPDOWN_DASHBOARD_SUCCESS: 'GET_DROPDOWN_DASHBOARD_SUCCESS',
	GET_DROPDOWN_DASHBOARD_ERROR: 'GET_DROPDOWN_DASHBOARD_ERROR'
};

const updateStatus = (type, data) => ({
	type,
	data,
});

const getItemDashboardTeam = (date) => {
	// let convertDate = moment(new Date(date)).format('YYYY/MM/DD');
	const config = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
		},
	};

	return (dispatch) => {
		// Middleware thunk here, allow return a new action
		callApi(`${host.serverTest}api/dashboards/teams?current_date=${date}`, config,
			(data) => {
				dispatch(updateStatus(ACTIONS.GET_ITEM_DASHBOARDS_TEAM_SUCCESS, data));
			},
			(err) => {
				dispatch(updateStatus(ACTIONS.GET_ITEM_DASHBOARDS_TEAM_ERROR, err));
			});
	};
};

const getItemDashboard = () => {
	const config = {
		method: 'GET',
		headers: {
			'accept': 'application/json',
			'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
		},
	};
	return (dispatch) => {
		callApi(`${host.serverTest}api/dashboards`, config,
			(data) => {
				dispatch(updateStatus(ACTIONS.GET_ITEM_DASHBOARDS_SUCCESS, data));
			},
			(err) => {
				dispatch(updateStatus(ACTIONS.GET_ITEM_DASHBOARDS_ERROR, err));
			});
	};
};

const getTextScore = (text) => {
	if (text.left_team_score !== null) {
		let tmp = '';
		if (text.game_status_id == 5) {
			if(text.left_team_score > text.right_team_score) {
				tmp = '○';
			}
			if(text.left_team_score < text.right_team_score) {
				tmp = '●';
			}
			if(text.left_team_score === text.right_team_score) {
				tmp = '△';
			}
		}
		return `${tmp} ${text.left_team_score}-${text.right_team_score}`;
	}
	return '';

}

const getPitcherName = (value) => {
	const pitcherNameResult = value.sPitcherName && value.result ? '先発:' + value.sPitcherName : '';
	const pitcherName = value.sPitcherName ? '先発:' + value.sPitcherName : '';
	return pitcherNameResult || pitcherName;
};

const convertData = (data, state) => {
	let dt = data.map(value => {
		let dates = (value.data || []).map(date => date.teamNameResultDate);
		let converDate = dates.map(d => moment(d, "YYYY/MM/DD").format('MM/DD'));
		let getIndex = state.map(x => {
			return converDate.indexOf(x);
		});
		let ds = (value.data || []).map(it => {
			const teamName = it.team_name_s ? it.team_name_s : '';
			return {
				text: {
					name: it.result ? getTextScore(it.result) + ' ' + teamName : teamName,
					action: getPitcherName(it),
				},
				url: '/game/' + it.id + "/" + it.team_id + "/" + moment(it.teamNameResultDate, "YYYY/MM/DD").format('YYYYMMDD'),
				link: it.result ? true : false,
				it: it,
				time: moment(it.teamNameResultDate, "YYYY/MM/DD").unix()
			}
		});
		getIndex.forEach(gt => {
			if (Number(gt) === -1) {
				ds.splice(getIndex.indexOf(gt), 0, { text: '' });
			}
		});
		ds = ds.sort(function (a, b) { return a.time - b.time });

		return { item: [{
			text: value.team_name_s,
			url: '/team-report/' + value.id,
			link: true
		}, ...ds] }
	});
	return dt;
};

const getDropdownDashboard = () => {
	const config = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
		},
	};
	return (dispatch) => {
		// Middleware thunk here, allow return a new action
		callApi(`${host.serverTest}api/masters/teams`, config,
			(data) => {
				dispatch(updateStatus(ACTIONS.GET_DROPDOWN_DASHBOARD_SUCCESS, data));
			},
			(err) => {
				dispatch(updateStatus(ACTIONS.GET_DROPDOWN_DASHBOARD_ERROR, err));
			});
	};
}

const converDataDashboard = (data) => {
	return data.map((items, index) => {
		return {
			team_id: items.team_id,
			item: [
				{ text: items.rank },
				{ text: items.teamName_s, img: detectIconById(items.team_id) },
				{ text: items.teamNameResultTotalPoints },
				{ text: items.teamNameResultWinPoints },
				{ text: items.teamNameResultLossPoints },
				{ text: items.teamNameResultDrawsPoints },
				{ text: convertPercentage(items.teamNameResultPercentageEstimateToWinPoints) },
				{ text: items.teamNameResultBehindDecimalPoints },
				{ text: items.left_game},
				{ text: items.streak},
				{ text: items.rs},
				{ text: items.ra},
				{ text: items.avg},
				{ text: items.hr},
				{ text: items.sb},
				{ text: items.era},
			]
		}
	});
};

const convertPercentage = (number) => {
	if (!number) return;

	number = numeral(number).format('0.000');
	if (number < 1) {
		let srt = number.toString();
		srt = srt.substr(1);
		return srt;
	} else {
		return number;
	}
}

export { ACTIONS, getItemDashboardTeam, convertData, getTextScore, getPitcherName, getItemDashboard, getDropdownDashboard, converDataDashboard };
